module.exports = __webpack_public_path__ + "site/img/team_sub_title_1.e2d6fb10.svg";